<template>
    <div class="row justify-content-center">
        <step-back-button v-if="canGoPrevious" @click="this.onPrevious"/>
        <transition v-bind:name="transitionName" mode='out-in'>
            <component class="form-container" :is='currentStepComponent' :suitability="suitability" :validation-errors="validationErrors" @on-previous="this.onPrevious" @on-submit="this.atualizarSolicitacao" @loading-toggle="handleLoadingToggle"></component>
        </transition>
    </div>
</template>

<style lang="scss" scoped>
@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";

    tr {
            border:none!important;
  			border-bottom: none;
  		}
  
  .card {
  	margin-bottom: 30px;
  }

  .item {
  	margin-bottom: 20px;

  	p {
  		padding: 0 0 5px 0;
  		margin: 0px;
  		color: #000;
  		font-weight: bold;

  		strong {
			color: $c3;
  		}
  	}

  	table {
  		thead {
  			th {
  				border-top:none;
  			}
  		}
  		tr {
  			border-bottom: none;
  		}

  		&.forms {
  			margin:0 0 20px;
  			td {
  				padding:2px 0;
  			}
  		}
  	}
  }

  .list-check {

  	li {
  		display: inline-block;
  		padding-right: 30px;
  		text-transform: uppercase;
  		font-weight: bold;

  		i {
  			color: green;
  		}
  	}
  }

  .form-check {
  	display: flex;


  	label {
  		font-size: 15px!important;
  		font-weight: normal!important;
  	}
  }

</style>


<style lang="scss">
.forms {
    tr {
        border:none!important;
    }
}
.app-div
{
        width: 100% !important;
}
</style>


<script>
    /* eslint-disable */
    import ApiClient from '../utils/api-client'
    import steps from '@/components/InformationSuitability'
    import * as mutationTypes from '@/store/mutation-types.js'
    import ArrayHelper from '@/utils/array-helper'
    import HubConsultaClient from '../utils/hub-consulta-client'
    import StepBackButton from '@/components/StepBackButton'

    let components = Object.assign({StepBackButton}, steps)

    export default {
        data() {
            return {
                transitionName: 'slide-left',
                suitabilityId: "",
                suitability: null,
                validationErrors: []
            }
        },
        components: components,
        computed: {
            currentStepComponent: function () {
                
                return this.suitability ? `${this.suitability.Status}-step` : null
            },
            progress: function () {
                
                const stepsAmount = Object.keys(steps).length
                const currentStepNumber = Object.keys(steps).indexOf(this.currentStepComponent) + 1
                return Math.round((currentStepNumber * 100) / stepsAmount)
            },
            canGoPrevious: function () {
                if (!this.suitability) return false
                
                return this.suitability.Status != "inicio-questionario" && this.suitability.Status != "confirmacao"
            }
        },
        methods: {
            atualizarSolicitacao: function (data) {
                
                
                data = Object.assign(data, { step_type: 'next' })
                this.transitionName = 'slide-left'

                if(data.Aceite != undefined && data.Aceite != null)
                {
                    this.ConsultarTipoInvestidor(data);
                }
                else{
                    this.$store.commit(mutationTypes.START_LOADING)
                    
                    // console.log("mandou",this.suitabilityId);
                    ApiClient.put(`suitability/${this.suitabilityId}/investidor`, { data: data })
                        .then(response => {
                            this.suitability = response.data
                            this.$store.commit(mutationTypes.STOP_LOADING);window.scrollTo(0,0);
                        })
                        .catch(error => {

                            this.validationErrors = error.response.data.errors
                            const errorMessages = this.validationErrors.map(error => error.detail)
                            this.$Notify.error(ArrayHelper.toSentence(errorMessages))
                            this.$store.commit(mutationTypes.STOP_LOADING);window.scrollTo(0,0);
                        })
                        
                    this.$store.commit(mutationTypes.STOP_LOADING)
                }
            },
            onPrevious: function () {
                this.transitionName = 'slide-right'
                
                this.$store.commit(mutationTypes.START_LOADING)
                ApiClient.put(`suitability/${this.suitabilityId}/investidor`, { data: { step_type: 'previous' } })
                    .then(response => {
                        this.suitability = response.data
                        window.scrollTo(0,0);
                        this.$store.commit(mutationTypes.STOP_LOADING);
                    }).catch(()=>{this.$store.commit(mutationTypes.STOP_LOADING); window.scrollTo(0,0);})
                    
             this.$store.commit(mutationTypes.STOP_LOADING)
            },
            handleLoadingToggle(isLoading) {
                //  console.log("handleLoadingToggle");
                if (isLoading) {
                    this.$store.commit(mutationTypes.START_LOADING)
                } else {
                    this.$store.commit(mutationTypes.STOP_LOADING)
                }
            },
            ConsultarTipoInvestidor(data) {
                // console.log("ConsultarTipoInvestidor");

                    HubConsultaClient.obterPerfilInvestidor(this.suitabilityId)
                                        .then(responsePerfil => {
                                        //    console.log("obterPerfilInvestidor",responsePerfil);

                                              this.$store.commit(mutationTypes.START_LOADING)
                    
                                                ApiClient.put(`suitability/${this.suitabilityId}/investidor`, { data: data })
                                                    .then(response => {

                                                        // console.log("resposta",response);
                                                        this.suitability = response.data
                                                        this.suitability.Nome = responsePerfil.data.Nome;
                                                        this.$store.commit(mutationTypes.STOP_LOADING);
                                                    })
                                                    .catch(error => {

                                                        // console.log("erro",error);
                                                        this.validationErrors = error.response.data.errors
                                                        const errorMessages = this.validationErrors.map(error => error.detail)
                                                        this.$Notify.error(ArrayHelper.toSentence(errorMessages))
                                                        this.$store.commit(mutationTypes.STOP_LOADING);
                                                    })
                                                this.$store.commit(mutationTypes.STOP_LOADING)

                                              //Atualiza o usuário
                                                this.$store.dispatch('updateUser')
                                                            .then()
                                                            .catch(error => {
                                                                const errorMessages = error.response.data.errors.map(error => error.detail)
                                                                this.$Notify.error(ArrayHelper.toSentence(errorMessages))
                                                            })

                                        })
                                        .catch(error => {
                                            
                                            console.log("erro ao obterPerfilInvestidor");
                                        });
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/informacoes-adicionais/suitability',
                    title: 'Suitability',
                })
            },
        },
        async created() {
            if (this.$store.state.currentUser.hassuitability) {
                let urlArray = window.location.toString().split('/')
                window.location = urlArray[0] + "//" + urlArray[2]
            }
            ApiClient.get(`suitability`)
            .then(response => {
                this.suitability = response.data
                this.suitabilityId = this.suitability.insertedIds[0];
                this.suitability.Status = "inicio-questionario"
                this.$store.commit(mutationTypes.STOP_LOADING);
                
            })
            .catch((err)=>{this.$store.commit(mutationTypes.STOP_LOADING)})
            
            //tagueamento GA
            await this.taggingGA();
        },
        beforeUpdate() {
            this.$Loading.update(this.progress)
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/InformationSuitability.vue